<template>
  <div class="pt-8 flex-1 flex flex-col bg-white">
    <div class="flex items-center px-6">
      <router-link :to="{ name: 'account' }">
        <svg
          class="w-8 h-8 text-gray-600 -ml-3"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </router-link>
      <div>
        <h1 class="text-2xl font-medium text-gray-800 ml-6">
          {{ $t("global.Email") }}
        </h1>
      </div>
    </div>

    <div class="w-full mt-6 px-6">
      <form action="#" method="POST" @submit.prevent="updateEmail">
        <div class="mt-1 relative rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
          >
            <!-- Heroicon name: solid/mail -->
            <svg
              class="mt-0.5 h-5 w-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              ></path>
            </svg>
          </div>
          <input
            v-model="email"
            id="email"
            :placeholder="$t('global.Email')"
            type="email"
            required
            class="pl-12 bg-gray-primary-100 appearance-none block w-full py-5 px-4 rounded-lg text-gray-500 placeholder-gray-400 focus:outline-none focus:border-blue-400 transition duration-150 ease-in-out font-medium sm:leading-5"
          />
        </div>
        <div class="mt-12 text-center">
          <button
            type="submit"
            class="w-full text-white bg-blue-primary-500 flex items-center justify-center rounded-lg py-4 border border-transparent"
          >
            {{ $t("global.Confirm") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import auth from "@/api/auth";

export default {
  data() {
    return {
      email: ""
    };
  },

  computed: {
    ...mapState("auth", ["user"])
  },

  mounted() {
    this.email = this.user.email;
  },

  methods: {
    updateEmail() {
      auth
        .update({
          _method: "PUT",
          email: this.email
        })
        .then(res => {
          console.log(res.status);
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  }
};
</script>
